export const FIND_FILE_FAILURE = 'FIND_FILE_FAILURE';

export const findFileFailure = error => ({
    type: FIND_FILE_FAILURE,
    payload: error,
    error: true,
});
